import AsyncStorage from "@react-native-async-storage/async-storage";
import { useCallback, useEffect, useState } from "react";

export function useInvitationToken() {
  const [token, setToken] = useState<string>();

  const setExternalTokenAsync = useCallback(
    async (newToken: string | undefined, optimistic: boolean) => {
      if (optimistic) {
        setToken(newToken);
      }

      if (newToken) {
        await AsyncStorage.setItem("gotips-invitation-token", newToken);
      } else {
        await AsyncStorage.removeItem("gotips-invitation-token");
      }

      if (!optimistic) {
        setToken(newToken);
      }

      return newToken;
    },
    []
  );

  const setExternalToken = useCallback(
    (newToken: string | undefined) => {
      setExternalTokenAsync(newToken, true);
    },
    [setToken]
  );

  useEffect(() => {
    AsyncStorage.getItem("gotips-invitation-token").then((token) =>
      setToken(token ?? undefined)
    );
  }, []);

  return [token, setExternalToken, setExternalTokenAsync] as const;
}
